import { Asterisk } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="marquee-paused relative overflow-hidden border-y border-line bg-paperdeep py-6" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`whitespace-nowrap px-8 text-2xl sm:text-3xl tracking-tight ${i % 2 === 0 ? "font-serif italic text-ink/70" : "font-mono text-sm uppercase tracking-[0.24em] text-wine/80"}`}>
                  {item}
                </span>
                <Asterisk size={18} className="text-amber shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
